// EN
export const propAuthLocksHc = {
  autoridades: {
    breadcrumbCurrent: "Zuständige Behörden",
    selectorLabel: "Wählen Sie die für Ihre Region zuständige Polizeibehörde",

    // Shared status fragments
    msgConnected: "Verbunden.",
    msgValidated: "Geprüft.",
    msgValidationError: "Fehler bei der Prüfung.",

    // SES Hospedajes
    sesSubtitle: "Staatssekretariat für Sicherheit – Innenministerium",
    sesConnectedText: "Die Check-ins werden automatisch an SES Hospedajes übermittelt.",
    sesVerifyCreds: "Prüfen Sie die eingegebenen Zugangsdaten.",
    sesNotConnected: "Sie haben noch kein Konto bei SES Hospedajes verbunden.",
    updateConnectedAccount: "Verbundenes Konto aktualisieren",

    // Ertzaintza A19
    ertzSubtitle: "Autonome Polizei des Baskenlands – Reisendenregister",
    ertzConnectedText: "Die Check-ins werden automatisch an die Ertzaintza übermittelt.",
    ertzVerifyCif: "Prüfen Sie die CIF und den Betriebscode.",
    ertzCredsSaved: 'Zugangsdaten gespeichert. Drücken Sie „Verbindung prüfen“, um den Zugang zu testen.',
    ertzCifLabel: "CIF des Betriebs",
    ertzCifPlaceholder: "z. B. B12345678",
    ertzCifHint: "Max. 10 Zeichen. Bei der Ertzaintza registrierte CIF des Vermieters.",
    ertzCodeLabel: "Betriebscode",
    ertzCodePlaceholder: "z. B. 01000001",
    ertzCodeHint: "Wird von der Ertzaintza bei der Registrierung des Betriebs vergeben.",
    envLabel: "Umgebung",
    envPre: "Vorproduktion (Test)",
    envPro: "Produktion",
    envHint: 'Nutzen Sie „Vorproduktion“, um vor der Aktivierung in der Produktion zu prüfen.',
    verifying: "Wird geprüft...",
    verifyConnection: "Verbindung prüfen",
    saving: "Wird gespeichert...",
    updateCredentials: "Zugangsdaten aktualisieren",
    saveAndConnect: "Speichern und verbinden",

    // Mossos d'Esquadra
    mossosSubtitle: "Generalitat de Catalunya – Registre de viatgers d'establiments d'hostalatge",

    // SIRE
    sireSubtitle: "Informationssystem zur Ausländerregistrierung – Migración Colombia",
    sireConnectedText: "Die Check-ins werden automatisch übermittelt.",
    sireRevisaCreds: "Prüfen Sie die Zugangsdaten.",
    docTypeLabel: "Dokumentart",
    selectTypePlaceholder: "Art auswählen",
    docNumberLabel: "Dokumentnummer",
    docNumberPlaceholder: "z. B. 123456789",
    passwordLabel: "Passwort",
    sirePasswordPlaceholder: "SIRE-Passwort",
    showHideTitle: "Ein-/ausblenden",
    saveChanges: "Änderungen speichern",

    // TRA
    traSubtitle: "Ministerium für Handel, Industrie und Tourismus – Autorisierungstoken",
    traReportsText: "Automatische Meldungen aktiviert.",
    traRevisaToken: "Prüfen Sie Token/RNT.",
    traTokenLabel: "Autorisierungstoken",
    traTokenPlaceholder: "Fügen Sie hier den von der TRA ausgestellten Token ein",
    traCurrentToken: "Aktueller Token: {token}",
    traNoTokenHint: "Wenn Sie noch keinen PMS-Token haben, können Sie ihn erzeugen unter",
    traRntLabel: "RNT des Betriebs",
    traRntPlaceholder: "Nur Zahlen (z. B. 123456)",
    traRntHint: "Es muss die aktive RNT des Betriebs sein (5 bis 15 Stellen).",

    // Document types (Colombia)
    docTypeCitizenId: "Bürgerausweis",
    docTypeForeignerId: "Ausländerausweis",

    // Alloggiati Web (residual placeholder)
    alloggiatiIdPlaceholder: "z. B. 1234",

    // Toasts / script messages
    needSaveListing: "Sie müssen das Inserat zuerst speichern.",
    authChangedErtz: "Behörde auf Ertzaintza (Baskenland) geändert.",
    authChangedMossos: "Behörde auf Mossos d'Esquadra (Katalonien) geändert.",
    authChangedSes: "Behörde auf SES Hospedajes geändert.",
    authChangeError: "Die Behörde konnte nicht geändert werden.",
    ertzSaved: "Zugangsdaten der Ertzaintza gespeichert.",
    saveGenericError: "Fehler beim Speichern.",
    ertzSaveError: "Fehler beim Speichern der Zugangsdaten der Ertzaintza.",
    ertzTestOk: "Verbindung mit der Ertzaintza erfolgreich geprüft.",
    testFailedCheck: "Prüfung fehlgeschlagen. Kontrollieren Sie die Angaben.",
    ertzTestError: "Fehler beim Prüfen der Verbindung mit der Ertzaintza.",
    mossosNeedCreds: "Geben Sie Benutzername und Passwort für die Website der Mossos ein.",
    mossosFound: "{count} Betrieb gefunden. Wählen Sie Ihren aus. | {count} Betriebe gefunden. Wählen Sie Ihren aus.",
    mossosNoEstablishments: "In diesem Konto wurden keine Betriebe gefunden.",
    mossosConnError: "Verbindung mit Mossos nicht möglich. Prüfen Sie Benutzername und Passwort.",
    mossosNeedFields: "Ergänzen Sie die Polizeikennung und den Betriebscode.",
    mossosSaved: "Zugangsdaten der Mossos gespeichert.",
    mossosSaveError: "Fehler beim Speichern der Zugangsdaten der Mossos.",
    mossosTestOk: "Verbindung mit Mossos erfolgreich geprüft.",
    mossosTestError: "Fehler beim Prüfen der Verbindung mit Mossos.",
    mossosFileOk: "Datei erzeugt. Laden Sie sie auf der Website der Mossos hoch (Fitxers massius).",
    mossosNoTravelers: "Es stehen keine Reisenden zur Übermittlung an.",
    mossosConfigFirst: "Richten Sie zuerst den Betrieb ein.",
    mossosFileError: "Die Datei konnte nicht erzeugt werden.",
    sireCompleteData: "Ergänzen Sie die für SIRE erforderlichen Daten.",
    sireSaved: "SIRE erfolgreich gespeichert.",
    sireSaveFailed: "SIRE konnte nicht gespeichert werden.",
    sireSaveError: "Fehler beim Speichern von SIRE.",
    sireDeactivated: "SIRE deaktiviert.",
    sireActivated: "SIRE aktiviert.",
    sireStateFailed: "Der Status von SIRE konnte nicht geändert werden.",
    sireStateError: "Fehler beim Ändern des Status von SIRE.",
    traNeedToken: "Geben Sie den Token und eine gültige RNT ein (nur Zahlen).",
    traSaved: "TRA erfolgreich gespeichert.",
    traSaveFailed: "TRA konnte nicht gespeichert werden.",
    traSaveError: "Fehler beim Speichern von TRA.",
    traDeactivated: "TRA deaktiviert.",
    traActivated: "TRA aktiviert.",
    traStateFailed: "Der Status von TRA konnte nicht geändert werden.",
    traStateError: "Fehler beim Ändern des Status von TRA.",
    stateChangeFailed: "Der Status konnte nicht geändert werden.",
    alloggiatiStateError: "Fehler beim Ändern des Status von Alloggiati Web.",
    ross1000StateError: "Fehler beim Ändern des Status von ROSS 1000.",
  },

  smartLocks: {
    loadingConfig: "Konfiguration wird geladen…",
    accessKeyTypeLabel: "Art des Zugangsschlüssels",
    selectLockPlaceholder: "Schloss auswählen",
    optionStatic: "Statischer Schlüssel",
    optionTtlock: "TTLock - Dynamisches Schloss",
    optionTedee: "Tedee - Dynamisches Schloss",
    optionShelly: "Shelly - Smartes Relais",
    optionYacan: "YACAN - Smartes Schloss",
    optionAkiles: "Akiles - Intelligentes Schloss",
    optionOther: "Eine andere Marke, die hier nicht steht…",
    pillTedee: "Dynamischer Zugang (Tedee)",
    pillTtlock: "Dynamischer Zugang (TTLock)",
    pillShelly: "Fernöffnung (Shelly)",
    pillYacan: "Verwalteter Zugang (YACAN)",
    pillAkiles: "Akiles verbunden",
    pillStatic: "Statischer Zugang",
    pillOther: "Schreiben Sie uns, wir helfen Ihnen bei der Integration",
    disconnecting: "Wird getrennt…",
    disconnect: "Trennen",
    emptyTitle: "Verbinden Sie Ihr smartes Schloss",
    emptyText: "Wählen Sie oben im Menü Ihre Marke aus, um sie zu verbinden und für jede Buchung automatisch einen neuen Schlüssel zu erzeugen.",
    emptyBrandOther: "Andere Marken",
    unitFallback: "Einheit {id}",
    staticModeInfo: "Statischer Modus ausgewählt. Geben Sie einen Schlüssel ein und drücken Sie Speichern, um ihn anzuwenden.",
    saveTypeError: "Die Zugangsart konnte nicht gespeichert werden",
    disconnectSuccess: "Schloss getrennt",
    disconnectError: "Das Schloss konnte nicht getrennt werden.",
  },

  rates: {
    pageTitle: "Tarife",
    loading: "Tarife werden geladen…",
    roomsCount: "{count} Zimmer | {count} Zimmer",
    singleUnit: "Einzelne Einheit",
    newBtn: "Neu",
    colName: "Name",
    colAdjustment: "Anpassung",
    colFinal: "Endpreis",
    labelMain: "Haupt",
    labelDerived: "Abgeleitet",
    base: "Basis",
    editTitle: "Bearbeiten",
    copyTitle: "In eine andere Einheit kopieren",
    deleteTitle: "Löschen",
    noDerived: "Für diesen Tarif gibt es keine abgeleiteten Tarife.",
    emptyTitle: "Keine Haupttarife",
    emptyText: "Legen Sie einen Haupttarif für diese Einheit an, danach können Sie abgeleitete Tarife erstellen.",
    emptyCreate: "Ersten Haupttarif anlegen",
    globalEmptyTitle: "Keine Einheiten geladen",
    globalEmptyText: "Legen Sie zuerst Zimmer bzw. Einheiten an, um Tarife verwalten zu können.",
    editRate: "Tarif bearbeiten",
    newRate: "Neuer Tarif",
    fieldName: "Name",
    namePlaceholder: "z. B. Flexibler Tarif",
    validityPeriod: "Gültigkeitszeitraum",
    validityPermanent: "Dauerhaft",
    validityCustom: "Individuell",
    validityHintCustom: "Optional: gilt nur innerhalb des Zeitraums",
    validityHintPermanent: "Tarif immer gültig",
    startLabel: "Start",
    endLabel: "Ende",
    pricePerNight: "Preis pro Nacht",
    taxIncluded: "Steuern inbegriffen",
    occupancy: "Belegung",
    guestsNumber: "Anzahl der Gäste",
    minStay: "Mindestaufenthalt",
    maxStay: "Höchstaufenthalt",
    description: "Beschreibung",
    optional: "Optional",
    rateplanBase: "Basistarif",
    selectRateplanBase: "Basistarif auswählen",
    rateplanBaseHint: "Wählen Sie den Tarif, auf dessen Grundlage dieser abgeleitete Tarif berechnet wird.",
    derivedNamePlaceholder: "z. B. Booking.com, Airbnb…",
    derivedNameHint: "Dieser Name hilft Ihnen, den Tarif beim Zuordnen der OTAs wiederzuerkennen.",
    adjustmentType: "Art der Anpassung",
    percentage: "Prozentsatz",
    fixedAmount: "Fester Betrag",
    adjustmentValue: "Wert der Anpassung",
    adjustmentValueHint: "(negativ für einen Rabatt)",
    preview: "Vorschau",
    basePrice: "Grundpreis",
    increment: "Aufschlag",
    discount: "Rabatt",
    cancel: "Abbrechen",
    saving: "Wird gespeichert...",
    update: "Aktualisieren",
    create: "Anlegen",
    deleteModalTitle: "Tarif löschen",
    deleteWarnStrong: "Diese Aktion kann nicht rückgängig gemacht werden.",
    deleteWarnLead: "Sie sind dabei, Folgendes zu löschen:",
    deleteCascadeLabel: "Auch die abgeleiteten Tarife löschen ({count})",
    deleteCascadeHint: "Ist ein abgeleiteter Tarif mit einer OTA verknüpft, wird das Löschen blockiert.",
    deleteConfirmLabel: "Geben Sie zur Bestätigung den genauen Namen ein:",
    deleteConfirmPlaceholder: "Namen genau eingeben",
    deleteConfirmHint: "Das verhindert versehentliches Löschen.",
    deleting: "Wird gelöscht...",
    deleteConfirmBtn: "Endgültig löschen",
    copyModalTitle: "Tarif in eine andere Einheit kopieren",
    copyOrigin: "Herkunft:",
    copyRate: "Tarif:",
    copyTargetUnit: "Zieleinheit",
    selectUnit: "Einheit auswählen",
    copySameUnitHint: "Sie können nicht in dieselbe Einheit kopieren.",
    copyTargetBaseRate: "Basistarif im Ziel",
    selectMainRate: "Haupttarif auswählen",
    copyDerivedHint: "Dieser abgeleitete Tarif wird in der Zieleinheit mit diesem Haupttarif verknüpft.",
    copyNoMainRates: "Die Zieleinheit hat keine Haupttarife. Legen Sie zuerst einen an oder kopieren Sie einen.",
    copyNewNameLabel: "Name im Ziel",
    copyRenameHint: "Sie können ihn umbenennen, um Duplikate zu vermeiden.",
    copyCascadeLabel: "Auch die abgeleiteten Tarife kopieren ({count})",
    copyCascadeHint: "Es werden neue abgeleitete Tarife angelegt, die auf den kopierten Haupttarif verweisen.",
    copying: "Wird kopiert...",
    copyBtn: "Kopieren",

    // Toasts / script messages
    loadError: "Fehler beim Laden der Tarife",
    rangeErrorSelect: "Sie müssen einen gültigen Zeitraum auswählen",
    rangeErrorStartEnd: "Das Startdatum darf nicht nach dem Enddatum liegen",
    rangeErrorMinStay: "Der Mindestaufenthalt beträgt {minStay} Nächte, der gewählte Zeitraum hat aber {nights} Nächte",
    invalidUnit: "Ungültige Einheit",
    completeRequired: "Füllen Sie die Pflichtfelder aus",
    updated: "Aktualisiert",
    created: "Angelegt",
    saveError: "Fehler beim Speichern",
    deleted: "Gelöscht",
    deleteLinkedOta: "Löschen nicht möglich: mit einer OTA verknüpft.",
    deleteGenericError: "Fehler beim Löschen",
    deleteDerivedError: "Der abgeleitete Tarif konnte nicht gelöscht werden",
    copied: "Kopiert",
    copyGenericError: "Fehler beim Kopieren",
    invalidTargetUnit: "Ungültige Zieleinheit",
    selectTargetBaseError: "Wählen Sie den Basistarif im Ziel aus, um den abgeleiteten Tarif zu verknüpfen.",
    invalidTargetBaseError: "Der ausgewählte Basistarif im Ziel ist für die Zieleinheit nicht gültig.",
    defaultRateName: "Tarif",
    defaultDerivedName: "Abgeleitet",
    copySuffix: "(Kopie)",
  },
};
